import { Observable } from 'rxjs';
import {
  ApiService,
  CREATE_USER_COMMENT_PATH,
  CreateUserCommentBody,
  GET_USER_COMMENTS_PATH,
  GetUserCommentsPathParams,
  GetUserCommentsResponse,
  REVOKE_USER_COMMENT_PATH,
  RevokeUserCommentPathParams
} from '@core-http';

export class UserCommentsService extends ApiService {
  addComment(payload: CreateUserCommentBody): Observable<void> {
    return this.httpClient.post<void>(`${this.env.apiUrl}${CREATE_USER_COMMENT_PATH}`, payload);
  }

  getComment(pathParams: GetUserCommentsPathParams): Observable<GetUserCommentsResponse> {
    const path: string = this.fillPathParams(GET_USER_COMMENTS_PATH, pathParams);

    return this.httpClient.get<GetUserCommentsResponse>(`${this.env.apiUrl}${path}`);
  }

  revokeComment(pathParams: RevokeUserCommentPathParams): Observable<void> {
    const path: string = this.fillPathParams(REVOKE_USER_COMMENT_PATH, pathParams);

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`);
  }
}
